export default __webpack_public_path__ + "static/media/bg-night.fce77132.jpg";